import { FC } from 'react';
import { useIntl } from 'react-intl';

import { PageTitle } from '../../../_metronic/layout/core';
import ProductListingTable from '../../modules/product-listing/components/ProductListingTable';

export const ProductListingPage: FC = () => {
  const intl = useIntl();

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'productListing.title' })}
      </PageTitle>
      <ProductListingTable />
    </>
  );
};
